<p-breadcrumb
  [model]="[{ label: 'Pedidos', routerLink: ['/orders'] }]"
  [home]="{ label: '', routerLink: ['/'] }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Pedidos</h5>
      <p>Gerencie todos os pedidos da loja</p>
    </div>
  </div>
</p-toolbar>

<p-table
  #table
  [value]="orders()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="numberFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Número do pedido"
          class="w-full"
        />
      </div>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="fullNameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome do cliente"
          class="w-full"
        />
      </div>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="productNameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome do produto"
          class="w-full"
        />
      </div>

      <div class="w-100">
        <p-select
          [options]="orderStatusOptions"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="Status"
          class="w-full"
          [(ngModel)]="statusFilter"
          (ngModelChange)="onFilterChange()"
        >
        </p-select>
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Número</th>
      <th>Status</th>
      <th>Cliente</th>
      <th>Produto</th>
      <th>Valor</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>
        <p class="font-bold">
          {{ item.number }}
        </p>
        <p class="mt-1">
          {{ item.placedAt | date: "dd/MM/yyyy HH:mm" }}
        </p>
      </td>
      <td>
        <div class="w-fit">
          <app-tag-status
            [status]="getStatusTag(item.status)"
            [text]="getStatusDescription(item.status)"
          ></app-tag-status>
        </div>
      </td>
      <td>
        {{ item.fullName }}
      </td>
      <td>{{ item.productName }}</td>
      <td class="font-bold">
        {{ item.fullPrice | currency: "USD" }}
      </td>
      <td>
        <p-button
          icon="ph ph-eye"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/orders/details/' + item.id"
        ></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
